import recorderUrl from 'posthog-js/dist/posthog-recorder.js?url'

/** Keep desktop analytics scripts inside the signed app and its self-only CSP. */
export function prepareDesktopPosthogScript(
  script: HTMLScriptElement,
): HTMLScriptElement | null {
  const path = new URL(script.src).pathname
  // PostHog currently requests lazy-recorder; older remote configurations can
  // request recorder. Both are provided by the installed SDK's recorder bundle.
  if (
    /^\/static\/(?:\d[^/]*\/)?(?:lazy-recorder|recorder|posthog-recorder)\.js$/.test(
      path,
    )
  ) {
    script.src = recorderUrl
    return script
  }
  // Reject remote executable config too. The SDK falls back to its JSON config
  // endpoint, which works with the existing connect-src policy. No site apps or
  // toolbar scripts should gain native desktop privileges.
  return null
}
